<template>
  <div>
    <div class="vx-row mt-5">
      <div class="vx-col sm:w-1/4 w-full mb-6">
        <label for="" class="vs-select--label">Tipo do Evento</label>
        <v-select
          :options="tiposEvento"
          name="Tipo Evento"
          id="Tipo Evento"
          v-model="form.idTipoEvento"
          label="label"
          :reduce="(item) => item.id"
          :disabled="dadosEvento.idStatus == 5 || dadosEvento.idStatus == 6"
          v-validate="{ required: true }"
          :state="validateState('Tipo Evento')"
          :danger="validateClass('Tipo Evento')"
        ></v-select>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-6">
        <label for="" class="vs-select--label">Status do Evento</label>
        <v-select
          :options="status"
          name="Status Evento"
          id="Status Evento"
          v-model="form.idStatus"
          label="label"
          :reduce="(item) => item.id"
          :disabled="dadosEvento.idStatus == 5 || dadosEvento.idStatus == 6"
          v-validate="{ required: true }"
          :state="validateState('Status Evento')"
          :danger="validateClass('Status Evento')"
        ></v-select>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-6" v-if="form.idTipoEvento == 1">
        <label for="" class="vs-select--label">Tipo de Colisão</label>
        <v-select
          :options="tiposColisao"
          name="Tipo de Colisão"
          id="Tipo de Colisão"
          v-model="form.idTipoColisao"
          label="label"
          :reduce="(item) => item.id"
          :disabled="dadosEvento.idStatus == 5 || dadosEvento.idStatus == 6"
          v-validate="{ required: true }"
          :state="validateState('Tipo de Colisão')"
          :danger="validateClass('Tipo de Colisão')"
        ></v-select>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for="" class="vs-select--label">Envolvimento</label>
        <v-select
          :options="tiposEnvolvimento"
          name="Envolvimento"
          id="Envolvimento"
          v-model="form.envolvimento"
          label="label"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
          :state="validateState('Envolvimento')"
          :danger="validateClass('Envolvimento')"
        ></v-select>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label">Data do Evento</label>
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePicker"
            v-model="form.dataHoraEvento"
            placeholder="DD/MM/YYYY HH:MM"
            name="Data do Evento"
            :state="validateState('Data do Evento')"
            :danger="validateClass('Data do Evento')"
          />
        </div>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label"
          >Data de Contato com assistencia</label
        >
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePicker"
            v-model="form.dataHoraContatoAssistencia"
            placeholder="DD/MM/YYYY HH:MM"
            name="Data de Contato com assistencia"
            :state="validateState('Data de Contato com assistencia')"
            :danger="validateClass('Data de Contato com assistencia')"
          />
        </div>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Número do boletim"
          name="Número do boletim"
          type="number"
          v-model="form.numeroBoletim"
          :state="validateState('Número do boletim')"
          :danger="validateClass('Número do boletim')"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label">Acionamento para terceiro</label>
        <vs-switch v-model="form.acionamentoParaTerceiro" color="success">
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label">Veículo está locomovendo</label>
        <vs-switch v-model="form.veiculoEmFuncionamento" color="success">
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label">Sindicante no local</label>
        <vs-switch v-model="form.sindicanteNoLocal" color="success">
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label">Polícia Compareceu</label>
        <vs-switch v-model="form.policiaCompareceu" color="success">
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <label for class="vs-input--label">Veículo em Oficina</label>
        <vs-switch v-model="form.veiculoEmOficina" color="success">
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
      <div v-if="form.veiculoEmOficina" class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Local em que se encontra o veículo"
          v-model="form.enderecoQueSeEncontra"
          name="Local em que se encontra o veículo"
          v-validate="{ required: true }"
          :state="validateState('Local em que se encontra o veículo')"
          :danger="validateClass('Local em que se encontra o veículo')"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <vs-textarea label="Descrição do boletim" v-model="form.relato" />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <vs-textarea label="Observações" v-model="form.observacao" />
      </div>
    </div>

    <vs-card>
      <div slot="header">
        <h3>Local do Evento</h3>
      </div>
      <formularioLocalEvento
        :formulario="form"
        :dadosLocalEvento="dadosLocalEvento"
        @formAlterado="alteraFormularioLocalEvento($event)"
      >
      </formularioLocalEvento>
    </vs-card>

    <vs-card>
      <div slot="header">
        <h3>Carro Reserva</h3>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/4 w-full mb-2">
          <label for class="vs-input--label">Solicitou carro</label>
          <vs-switch v-model="form.solicitaCarroReserva" color="success">
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
        <div
          v-if="form.solicitaCarroReserva"
          class="vx-col sm:w-1/4 w-full mb-2"
        >
          <vs-input
            class="w-full"
            label="Tempo de liberação (em dias)"
            type="number"
            v-model="form.carroReservaQtdDias"
            name="Tempo de liberação"
            @change="onChangeTempoLiberacaoCarroReserva($event.target.value)"
            v-validate="{ required: true }"
            :state="validateState('Tempo de liberação')"
            :danger="validateClass('Tempo de liberação')"
          />
        </div>
        <div
          v-if="form.solicitaCarroReserva"
          class="vx-col sm:w-1/4 w-full mb-2"
        >
          <label for class="vs-input--label">Data de liberação</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerDataLiberacao"
              v-model="form.carroReservaDataLiberacao"
              placeholder="DD/MM/YYYY HH:MM"
              name="Data de liberação"
              :state="validateState('Data de liberação')"
              :danger="validateClass('Data de liberação')"
            />
          </div>
        </div>
        <div
          v-if="form.solicitaCarroReserva"
          class="vx-col sm:w-1/4 w-full mb-2"
        >
          <label for class="vs-input--label">Data de devolução</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePicker"
              disabled
              v-model="form.carroReservaDataDevolucao"
              placeholder="DD/MM/YYYY HH:MM"
              name="Data de devolução"
              :state="validateState('Data de devolução')"
              :danger="validateClass('Data de devolução')"
            />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/1 w-full mb-2">
          <vs-textarea
            label="Observações sobre carro reserva"
            v-model="form.carroReservaObservacao"
          />
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import locale from '../../../locale';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import moment from 'moment';
import formularioLocalEvento from './formLocalEvento';
import vSelect from 'vue-select';

export default {
  props: ['dadosEvento', 'formulario', 'tiposEvento', 'tiposColisao', 'status'],
  watch: {
    dadosEvento() {
      this.preencheForm();
    },
  },
  components: {
    vSelect,
    flatPickr,
    formularioLocalEvento,
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'd/m/Y H:i',
        locale: Portuguese,
        time_24hr: true,
      },
      configdateTimePickerDataLiberacao: {
        onChange: (selectedDates) =>
          this.onChangeDataDeLiberacaoCarroReserva(selectedDates[0]),
        enableTime: true,
        dateFormat: 'd/m/Y H:i',
        locale: Portuguese,
        time_24hr: true,
      },
      tiposEnvolvimento: [
        { label: 'Selecione', id: null },
        { label: 'Vítima', id: 'Vítima' },
        { label: 'Causador', id: 'Causador' },
      ],
      dadosLocalEvento: {},
      form: {
        idTipoEvento: null,
        idTipoColisao: null,
        idStatus: null,
        policiaCompareceu: false,
        acionamentoParaTerceiro: false,
        veiculoEmOficina: false,
        enderecoQueSeEncontra: null,
        veiculoEmFuncionamento: false,
        dataHoraEvento: null,
        dataHoraContatoAssistencia: null,
        observacao: null,
        restricaoDescricao: null,
        relato: null,
        numeroBoletim: null,
        solicitaCarroReserva: null,
        carroReservaQtdDias: null,
        carroReservaDataLiberacao: null,
        carroReservaDataDevolucao: null,
        carroReservaObservacao: null,
        sindicanteNoLocal: false,
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      if (this.formulario.dadosGerais.idEvento) {
        this.form = this.formulario.dadosGerais;
        this.dadosLocalEvento = this.formulario.dadosGerais.dadosLocalEvento;
      } else if (this.dadosEvento.idEvento) {
        this.form.idEvento = this.dadosEvento.idEvento;
        this.form.idTipoEvento = this.dadosEvento.tipoEvento.idTipoEvento;
        this.form.idTipoColisao = this.dadosEvento.tipoColisao.idTipoColisao;
        this.form.envolvimento = this.dadosEvento.envolvimento;
        this.form.idStatus = this.dadosEvento.idStatus;
        this.form.policiaCompareceu = this.dadosEvento.policiaCompareceu;
        this.form.acionamentoParaTerceiro =
          this.dadosEvento.acionamentoParaTerceiro;
        this.form.veiculoEmOficina = this.dadosEvento.veiculoEmOficina;
        this.form.enderecoQueSeEncontra =
          this.dadosEvento.enderecoQueSeEncontra;
        this.form.veiculoEmFuncionamento =
          this.dadosEvento.veiculoEmFuncionamento;
        this.form.dataHoraContatoAssistencia =
          this.dadosEvento.dataHoraContatoAssistencia;
        this.form.dataHoraEvento = this.dadosEvento.dataHoraEvento;
        this.form.observacao = this.dadosEvento.observacao;
        this.form.relato = this.dadosEvento.relato;
        this.form.numeroBoletim = this.dadosEvento.numeroBoletim;
        this.form.sindicanteNoLocal = this.dadosEvento.sindicanteNoLocal;

        this.dadosLocalEvento = this.dadosEvento.enderecoEvento;
        this.form.solicitaCarroReserva = this.dadosEvento.solicitaCarroReserva;
        this.form.carroReservaQtdDias = this.dadosEvento.carroReservaQtdDias;
        this.form.carroReservaDataLiberacao =
          this.dadosEvento.carroReservaDataLiberacao;
        this.form.carroReservaDataDevolucao =
          this.dadosEvento.carroReservaDataDevolucao;
        this.form.carroReservaObservacao =
          this.dadosEvento.carroReservaObservacao;
      }
    },
    emitForm() {
      this.$emit('formAlterado', this.form);
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    formataDataStr(data) {
      var dia = data.split('/')[0];
      var mes = data.split('/')[1];
      var ano = data.split('/')[2];

      return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2);
    },
    alteraFormularioLocalEvento(dadosLocalEvento) {
      this.form.dadosLocalEvento = dadosLocalEvento;
    },
    onChangeDataDeLiberacaoCarroReserva(value) {
      const quantidadeDias = this.form.carroReservaQtdDias || 0;
      this.form.carroReservaDataDevolucao = moment(value)
        .add('days', quantidadeDias)
        .format('DD/MM/YYYY HH:mm');
    },
    onChangeTempoLiberacaoCarroReserva(value) {
      const quantidadeDias = parseInt(value) || 0;

      if (this.form.carroReservaDataLiberacao) {
        const datetimeFormat = 'DD/MM/YYYY HH:mm';
        const isInUTC = this.form.carroReservaDataLiberacao.includes('Z');
        const momentFormat = isInUTC ? undefined : datetimeFormat;

        this.form.carroReservaDataDevolucao = moment(
          this.form.carroReservaDataLiberacao,
          momentFormat,
        )
          .add('days', quantidadeDias)
          .format(datetimeFormat);
      }
    },
  },
  mounted() {
    this.preencheForm();
    this.$validator.localize('ptBr', locale);
  },
  created: function () {
    this.$watch('form', this.emitForm, {
      deep: true,
    });
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
input.flatpickr-input {
  width: 100%;
}

.vx-row.divider {
  border: 0.5px solid rgba(0, 0, 0, 0.08);
}
</style>
